import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ValueProps from "@/components/ValueProps";
import Offerings from "@/components/Offerings";
import Brands from "@/components/Brands";
import Dermo from "@/components/Dermo";
import Services from "@/components/Services";
import Promos from "@/components/Promos";
import About from "@/components/About";
import LocalCta from "@/components/LocalCta";
import Contacts from "@/components/Contacts";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Privacy from "@/components/Privacy";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <ValueProps />
      <Offerings />
      <Brands />
      <Dermo />
      <Services />
      <Promos />
      <About />
      <LocalCta />
      <Contacts />
    </main>
    <Footer />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, anchors: { offset: -84 } });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#faf8f5] text-[#1c1d1f]">
      <a
        href="#home"
        data-testid="skip-link"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:rounded-full focus:bg-[#0050e0] focus:px-5 focus:py-2.5 focus:text-sm focus:font-bold focus:text-white"
      >
        Salta al contenuto
      </a>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <FloatingWhatsApp />
    </div>
  );
}
